module.exports = __webpack_public_path__ + "img/bcmanchester.7cfe5482.jpg";